// extracted by css-extract-rspack-plugin
export default {"badge":"StackBadge-module__badge__FJFUi"};